var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcOnlineScamServiceBody2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 211,
    viewBox: "0 0 238 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2044_2678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.1436 28.1995C73.1436 20.9841 78.9928 15.1348 86.2083 15.1348L180.955 15.1348L180.955 154.862C180.955 162.078 175.106 167.927 167.89 167.927L73.1436 167.927L73.1436 28.1995Z",
    fill: "#FFCF85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.528 15.1348L182.169 15.1348C189.385 15.1348 195.234 20.984 195.234 28.1995L195.234 67.0424C195.234 74.2579 189.385 80.1071 182.169 80.1071L174.528 80.1071L174.528 15.1348Z",
    fill: "#FFCF85"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.7061,
    y: 40.124,
    width: 70.6842,
    height: 19.2775,
    fill: "#FFF2DE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2044_2678)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.893 128.159L148.893 80.064L156.258 80.064C156.628 78.6245 157.649 77.4458 158.987 76.8591C159.119 76.7121 159.273 76.5783 159.45 76.4624L189.864 56.5359C192.086 55.0803 195.238 55.577 196.904 57.6454L197.227 58.0463C200.144 61.666 199.356 66.6655 195.468 69.213L184.411 76.4568L192.994 76.4568C193.011 76.4566 193.029 76.4564 193.047 76.4564L204.499 76.4564C206.491 76.4564 208.106 78.0714 208.106 80.0636L208.106 86.0755C208.106 88.0676 206.491 89.6826 204.499 89.6826L194.774 89.6826L194.774 89.6832L201.832 89.6832C203.825 89.6832 205.44 91.2982 205.44 93.2904L205.44 98.0999C205.44 100.092 203.825 101.707 201.832 101.707L199.235 101.707C201.196 101.743 202.775 103.344 202.775 105.314L202.775 111.325C202.775 113.318 201.16 114.933 199.168 114.933L194.774 114.933L194.774 114.999C197.044 115.385 198.772 117.361 198.772 119.741L198.772 123.348C198.772 125.728 197.044 127.704 194.774 128.089L194.774 128.159L157.309 128.159L156.106 128.159L148.893 128.159Z",
    fill: "#FFDCD5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2044_2678)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 135.373,
    width: 63.7262,
    height: 133.464,
    transform: "rotate(-90 1 135.373)",
    fill: "#374969"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2044_2678)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.464,
    y: 131.767,
    width: 56.5119,
    height: 14.4286,
    transform: "rotate(-90 134.464 131.767)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 123,
    cy: 127.994,
    r: 4,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 127.994,
    r: 4,
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2044_2678",
    x: 144.893,
    y: 55.7012,
    width: 67.2139,
    height: 80.458,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2044_2678"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2044_2678",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2044_2678",
    x: -3,
    y: 71.6465,
    width: 141.464,
    height: 71.7266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2044_2678"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2044_2678",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2044_2678",
    x: 130.464,
    y: 75.2549,
    width: 22.4287,
    height: 64.5117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2044_2678"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2044_2678",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2044_2678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 237,
    height: 210,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOnlineScamServiceBody2);
export default __webpack_public_path__ + "static/media/IcOnlineScamServiceBody2.4fcb1f9163e3e4246d62ce63f74ceb0d.svg";
export { ForwardRef as ReactComponent };